import script from "./claim-record-card.vue?vue&type=script&lang=ts&setup=true"
export * from "./claim-record-card.vue?vue&type=script&lang=ts&setup=true"

import "./claim-record-card.vue?vue&type=style&index=0&id=69b00ba6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b00ba6"]])

export default __exports__